import { ChangeEvent, memo, useCallback, useState } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "./Highlight/Highlight";
import CompletableChecklist from "@coworker/apprestructured/src/task-management/components/CompletableChecklist/CompletableChecklist";
import ChecklistItem from "@coworker/apprestructured/src/task-management/types/ChecklistItem";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import { useTranslation } from "@coworker/locales";

function createItems({
  nbrOfItems,
  text,
}: {
  nbrOfItems: string;
  text: string;
}) {
  return Array.from({ length: parseInt(nbrOfItems) }).map((_, i) => ({
    title: `${text} ${i + 1}`,
    completed: false,
  }));
}

function CompletableChecklistDemo() {
  const [nbrOfItems, setNbrOfItems] = useState("5");
  const [text, setText] = useState("Item");
  const [items, setItems] = useState<ChecklistItem[]>(() =>
    createItems({ nbrOfItems, text })
  );
  const [disabled, setDisabled] = useState(false);

  const { t } = useTranslation();

  const handleNbrOfItemsChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const newNbrOfItems = e.target.value;
      setNbrOfItems(newNbrOfItems);
      setItems(createItems({ nbrOfItems: newNbrOfItems, text }));
    },
    [text]
  );

  const handleTextChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const newText = e.target.value;
      setText(newText);
      setItems(createItems({ nbrOfItems, text: newText }));
    },
    [nbrOfItems]
  );

  return (
    <Demo>
      <Name>CompletableChecklist</Name>
      <Highlight>
        <CompletableChecklist
          items={items}
          onItemsChange={setItems}
          label={t("toDosString")}
          disabled={disabled}
        />
      </Highlight>
      <Actions>
        <FixaInputField
          id="completablechecklistdemo-nbrOfItems"
          value={nbrOfItems}
          onChange={handleNbrOfItemsChange}
          type="number"
          min="0"
          max="100"
          label="nbrOfItems"
        />
        <FixaInputField
          id="completablechecklistdemo-text"
          value={text}
          onChange={handleTextChange}
          type="text"
          label="text"
        />
        <FixaCheckbox
          label="disabled"
          value="completablechecklistdemo-disabled"
          id="completablechecklistdemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(CompletableChecklistDemo);
